var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3544_1425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.893 6.21492C11.1623 5.96389 11.1771 5.54204 10.9261 5.2727C10.6751 5.00335 10.2532 4.98851 9.98389 5.23955L8.03314 7.0577L6.21498 5.10695C5.96395 4.8376 5.5421 4.82276 5.27276 5.0738C5.00342 5.32483 4.98857 5.74668 5.23961 6.01602L7.05776 7.96678L5.10701 9.78493C4.83767 10.036 4.82282 10.4578 5.07386 10.7272C5.32489 10.9965 5.74674 11.0113 6.01608 10.7603L7.96684 8.94215L9.78499 10.8929C10.036 11.1622 10.4579 11.1771 10.7272 10.9261C10.9966 10.675 11.0114 10.2532 10.7604 9.98383L8.94221 8.03308L10.893 6.21492Z",
    fill: "#7E8A96"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666687 7.99996C0.666687 3.94987 3.94993 0.666626 8.00002 0.666626C12.0501 0.666626 15.3334 3.94987 15.3334 7.99996C15.3334 12.05 12.0501 15.3333 8.00002 15.3333C3.94993 15.3333 0.666687 12.05 0.666687 7.99996ZM8.00002 14C4.68631 14 2.00002 11.3137 2.00002 7.99996C2.00002 4.68625 4.68631 1.99996 8.00002 1.99996C11.3137 1.99996 14 4.68625 14 7.99996C14 11.3137 11.3137 14 8.00002 14Z",
    fill: "#7E8A96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3544_1425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.2a90e37d.svg";
export { ForwardRef as ReactComponent };